export default {
  UPDATE_SELECTED_CURRENT_INVESTMENT_FILTER_VALUE: 'UPDATE_SELECTED_CURRENT_INVESTMENT_FILTER_VALUE',
  WATCH_INVESTMENT_FLAG_REQUESTED: 'WATCH_INVESTMENT_FLAG_REQUESTED',
  WATCH_INVESTMENT_FLAG_SUCCEEDED: 'WATCH_INVESTMENT_FLAG_SUCCEEDED',
  WATCH_INVESTMENT_FLAG_FAILED: 'WATCH_INVESTMENT_FLAG_FAILED',
};
